// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"4a57e309","249":"fc41da87","363":"27efa15b","531":"e6972d63","657":"463fff33","828":"d810e36e","838":"ed545dbf","844":"d184b542"}[chunkId] + ".chunk.js";
};